module.exports = __webpack_public_path__ + "media/produzione_background.54e1bc99.mp4";